<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface ConflictingCalendarItem {
  name: string
  group: string
}

defineProps<{
  items: ConflictingCalendarItem[]
}>()
</script>

<template>
  <div class="mt-5 w-full overflow-hidden rounded-lg border border-gray-200">
    <div class="flex border-b border-gray-200 bg-gray-50">
      <div class="flex-1 px-4 py-3 text-xs font-medium text-gray-600">
        {{ t('settings.calendar.calendar_name') }}
      </div>
      <div class="flex-1 px-4 py-3 text-xs font-medium text-gray-600">
        {{ t('settings.calendar.group_associated_with') }}
      </div>
    </div>
    <div class="bg-white">
      <div
        v-for="(calendar, index) in items"
        :key="index"
        class="flex border-b border-gray-200 last:border-b-0"
      >
        <div class="flex-1 px-4 py-3 text-sm text-gray-600">
          {{ calendar.name }}
        </div>
        <div class="flex-1 px-4 py-3 text-sm text-gray-600">
          {{ calendar.group }}
        </div>
      </div>
    </div>
  </div>
</template>
